import styled from 'styled-components'

import { TransparentIconButton } from '../../Button'
import { IconChevronLeft } from '@ui/elements/Icon'

export const DatepickerPrevNavButton = styled((props) => {
  return (
    <TransparentIconButton
      iconComponent={<IconChevronLeft />}
      {...props}
      aria-label='Previous'
    />
  )
})`
  position: absolute;
  top: ${(props) => props.theme.typography.pxToRem(18)};
  left: ${(props) => props.theme.typography.pxToRem(20)};
`
